import React from 'react';
import { Trophy, Users, ArrowRight, Sparkles } from 'lucide-react';

const CeremonySection = () => {
  return (
    <section className="relative py-24 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full px-6 py-2 mb-6">
            <Trophy className="w-5 h-5 text-[#D4AF37]" />
            <span className="text-[#D4AF37] font-bold text-sm">THE JOURNEY</span>
          </div>
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
            COMPLETION
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#FFD700]">
              TO COMMUNITY
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Your transformation doesn't end—it multiplies
          </p>
        </div>

        {/* Three-Step Journey */}
        <div className="max-w-5xl mx-auto">
          <div className="relative">
            {/* Connection Line */}
            <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-gradient-to-r from-[#D4AF37] via-[#FFD700] to-[#D4AF37] transform -translate-y-1/2 opacity-30" />
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
              {/* Step 1: Completion Ceremony */}
              <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#D4AF37]/30 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 hover:border-[#D4AF37]">
                <div className="w-20 h-20 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-full flex items-center justify-center mx-auto mb-6 relative">
                  <Trophy className="w-10 h-10 text-[#0a0a0a]" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#E63946] rounded-full flex items-center justify-center text-white font-bold text-sm">
                    1
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  COMPLETION CEREMONY
                </h3>
                <p className="text-gray-300 mb-4">
                  Celebrate your journey with a formal recognition ceremony honoring your dedication and growth.
                </p>
                <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg p-3">
                  <p className="text-sm text-[#D4AF37] font-semibold">Certificate of Completion</p>
                </div>
                
                {/* Arrow */}
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <ArrowRight className="w-8 h-8 text-[#D4AF37]" />
                </div>
              </div>

              {/* Step 2: ZOE Induction */}
              <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#D4AF37]/30 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 hover:border-[#D4AF37]">
                <div className="w-20 h-20 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-full flex items-center justify-center mx-auto mb-6 relative">
                  <Users className="w-10 h-10 text-[#0a0a0a]" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#E63946] rounded-full flex items-center justify-center text-white font-bold text-sm">
                    2
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  ZOE INDUCTION
                </h3>
                <p className="text-gray-300 mb-4">
                  Join the ZOE Fraternity—a brotherhood/sisterhood of transformed lives committed to supporting each other.
                </p>
                <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg p-3">
                  <p className="text-sm text-[#D4AF37] font-semibold">Lifetime Community Access</p>
                </div>
                
                {/* Arrow */}
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <ArrowRight className="w-8 h-8 text-[#D4AF37]" />
                </div>
              </div>

              {/* Step 3: Pay It Forward */}
              <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#D4AF37]/30 rounded-2xl p-8 text-center transform hover:scale-105 transition-all duration-300 hover:border-[#D4AF37]">
                <div className="w-20 h-20 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-full flex items-center justify-center mx-auto mb-6 relative">
                  <Sparkles className="w-10 h-10 text-[#0a0a0a]" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-[#E63946] rounded-full flex items-center justify-center text-white font-bold text-sm">
                    3
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  PAY IT FORWARD
                </h3>
                <p className="text-gray-300 mb-4">
                  Become a mentor and sponsor others on their journey—your transformation becomes their inspiration.
                </p>
                <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg p-3">
                  <p className="text-sm text-[#D4AF37] font-semibold">Create Ripple Effects</p>
                </div>
              </div>
            </div>
          </div>

          {/* Impact Statement */}
          <div className="mt-12 bg-gradient-to-r from-[#E63946]/10 via-[#D4AF37]/5 to-[#E63946]/10 border border-[#D4AF37]/30 rounded-2xl p-8 text-center">
            <p className="text-2xl md:text-3xl text-white font-semibold mb-4">
              "Your story becomes someone else's survival guide"
            </p>
            <p className="text-gray-400">
              The ZOE Fraternity creates a perpetual cycle of transformation, support, and hope
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CeremonySection;
